'use strict';

var FaresOptimizerDashboardToolbarDirective = function FaresOptimizerDashboardToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-dashboard-toolbar.html'),
    scope: true
  };
};
FaresOptimizerDashboardToolbarDirective.$inject = [];
module.exports = FaresOptimizerDashboardToolbarDirective;